import React from "react";
import Draggable from "react-draggable";
import LoadingOverlay from "react-loading-overlay";
import ReactTooltip from "react-tooltip";
import Loader from "../../../common/components/Loader";
import { RecommendationBand } from "../../../recommendations/components/Bands/RecommendationBand";
import { bands, tabs as consTabs } from "./constants";
import { FilterItem } from "./FilterItem";
import useMyFilters from "./useMyFilters";
import "../../../../assets/css/filter-dashboard-modal.css";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import Portal from "../../../common/components/Portal";
import { FilterSearch } from "../../../assets/components/FilterModal/FilterSearch";
import { AppliedFilters } from "../../../common/AppliedFilters";
import SaveFilterModal from "../SaveQueryModal";
import _ from "lodash";
import { getAppliedFiltersCount, hasActualFilter } from "../../../../utils/filtersUtils";
import WildcardIcon from "../../../../assets/img/wildcard-icon.svg";

export const MyFilters = ({
    dashboardFilterParams,
    onCancel,
    yearValues,
    submitMasterFilter,
    getListParams = {},
    isRecommendationTable,
    openAppliedFiltersPopup,
    filterCount,
    isDashboard,
    isSmartChartFilter = false,
    isCoreReportFilters = false,
    requiredFields = {},
    core_report_req_filters = {},
    queries,
    saveFilterSubmit,
    filterName,
    isCR = false,
    openSavedFilters,
    initialFieldSearch = ""
}) => {
    const {
        showBands,
        showDropdown,
        handleFilterView,
        masterFilterList,
        masterFilterCount,
        handleBandClick,
        dropdownLoader,
        handleFilterUpdate,
        filterData,
        filterName: currentFilterName,
        isDirty,
        handleSubmit,
        activeTab,
        setActiveTab,
        handleCancel,
        showCancelConfirmation,
        onCancelConfirm,
        setShowCancelConfirmation,
        dynamicBands,
        buildingDynamicBands,
        recommendationBands,
        filterFields: initialFields,
        clearAllFilters,
        getFilterCountByBand,
        getFilterCountByTab,
        setShowDropdown,
        setWildCardFilter,
        isLoading,
        fieldSearch,
        setFieldSearch,
        showAppliedFilters,
        setShowAppliedFilters,
        totalFilterCount,
        emptyDivRef,
        sectionRef,
        showWildcard,
        setShowWildcard,
        showWildcardField,
        setWildcardField,
        handleSaveFilerModal,
        showSaveFilterModal,
        setShowSaveFilterModal,
        handleSaveFilter,
        toggleFavorite,
        favorites,
        showFavoriteRemoveConfirmation,
        setFavoriteRemoveConfirmation,
        onFavoriteRemoveConfirmation,
        toggleStaticFci,
        toggleProjectCost,
        toggleCspStatus,
        cspStatusOptions,
        toggleAssetLifecycle,
        assetLifecycleOptions,
        isAdcOnlyProject,
        crLabel,
        getDashboardFilterBandLabel
    } = useMyFilters({
        dashboardFilterParams,
        submitMasterFilter,
        onCancel,
        getListParams,
        isRecommendationTable,
        queries,
        saveFilterSubmit,
        isDashboard,
        isSmartChartFilter,
        isCoreReportFilters,
        isCR,
        initialFieldSearch
    });
    const renderConfirmationModal = () => {
        if (!showCancelConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to cancel and lose all changes?"}
                        type="cancel"
                        message={"This action cannot be reverted, are you sure that you need to cancel?"}
                        onNo={() => setShowCancelConfirmation(false)}
                        onYes={onCancelConfirm}
                    />
                }
                onCancel={() => setShowCancelConfirmation(false)}
            />
        );
    };
    const renserSaveFilterModal = () => {
        if (!showSaveFilterModal) return null;
        return (
            <Portal
                body={
                    <SaveFilterModal
                        onCancel={() => setShowSaveFilterModal(false)}
                        onFilterSave={data => {
                            handleSaveFilter(data);
                        }}
                    />
                }
                onCancel={() => setShowCancelConfirmation(false)}
            />
        );
    };
    const filteredFilterData =
        filterData &&
        Object.keys(filterData)?.reduce((acc, key) => {
            if (key === "filters") {
                const filteredFilters = Object.fromEntries(
                    Object.entries(filterData[key]).filter(
                        ([key, value]) =>
                            ((value?.key !== "" && value?.key !== null) ||
                                ((value?.filters[0] === "null" || value?.filters[0] === "not_null" || value?.filters[0] === "count_gt_1") &&
                                    (value?.key === "" || value?.key === null))) &&
                            value?.filters?.length > 0
                    )
                );
                if (Object.keys(filteredFilters)?.length > 0) {
                    acc[key] = filteredFilters;
                }
            } else {
                acc[key] = filterData[key];
            }
            return acc;
        }, {});

    const hasSaveFilter = hasActualFilter(filterData);

    const renderAppliedFilters = () => {
        if (!showAppliedFilters) return null;
        return (
            <Portal
                body={
                    <AppliedFilters
                        myFilters={isSmartChartFilter || isCoreReportFilters ? filteredFilterData : filterData}
                        filterValues={{}}
                        showFiltersIcon={false}
                        onCancel={() => setShowAppliedFilters(false)}
                        source="dashboard"
                        MyfilterName={currentFilterName}
                        isCR={isCR}
                    />
                }
                onCancel={() => setShowAppliedFilters(false)}
            />
        );
    };
    const renderFavoriteRemoveConfirmationModal = () => {
        if (!showFavoriteRemoveConfirmation) return null;
        return (
            <Portal
                body={
                    <ConfirmationModal
                        heading={"Do you want to remove this from Favorites?"}
                        type="cancel"
                        message={"Are you sure?"}
                        onYes={() => onFavoriteRemoveConfirmation()}
                        onNo={() => setFavoriteRemoveConfirmation(false)}
                    />
                }
                onCancel={() => setFavoriteRemoveConfirmation(false)}
            />
        );
    };

    const tabs = {
        ...consTabs,
        building: { ...consTabs.building, bands: [...consTabs.building.bands, ...buildingDynamicBands] },

        recommendation: {
            ...consTabs.recommendation,
            label: isCR ? crLabel : consTabs.recommendation.label,
            bands: recommendationBands
        },
        ...((isDashboard || isRecommendationTable) && {
            favorites: {
                label: "Favorites",
                bands: []
            }
        })
    };
    if (!initialFields?.some(field => field?.band === bands.qa_qc && !field?.hide)) {
        delete tabs.qa_qc;
    }
    const selectedCspStatuses = Array.isArray(filterData?.csp_status) ? filterData.csp_status : ["recommendation"];
    let filterFields = isSmartChartFilter
        ? initialFields.filter(({ paramKey, dashboardOnly }) => paramKey !== "client_ids" && !dashboardOnly)
        : isCoreReportFilters
          ? initialFields?.filter(field => requiredFields.includes(field.paramKey) && !field?.dashboardOnly)
          : isRecommendationTable
            ? initialFields?.filter(field => !field?.dashboardOnly)
            : initialFields;
    filterFields = filterFields?.filter(field => field?.paramKey !== "csp_status");
    const activeCspSources = isDashboard ? selectedCspStatuses : isRecommendationTable ? [isCR ? "capital_request" : "recommendation"] : null;
    filterFields = filterFields?.filter(field => !field?.cspSource || !activeCspSources || activeCspSources.includes(field.cspSource));
    if (fieldSearch && fieldSearch?.toString()?.trim()?.length) {
        filterFields = filterFields.filter(field => field?.label?.toString()?.toLowerCase()?.includes(fieldSearch?.toString()?.toLowerCase()));
    }
    filterCount = isDashboard ? totalFilterCount : filterCount;
    let favFilters = [];

    if (favorites.length) {
        favFilters = filterFields?.filter(field => favorites?.includes(field?.key))?.map(fav => ({ ...fav, isFavorite: true }));
    }

    if (fieldSearch && fieldSearch?.trim()?.length) {
        filterFields = filterFields?.filter(field => field?.label?.toString()?.toLowerCase()?.includes(fieldSearch?.toLowerCase()));
        favFilters = favFilters?.filter(field => field?.label?.toString()?.toLowerCase()?.includes(fieldSearch?.toLowerCase()));
    }
    const uniqueFavFilters = _.uniqBy(favFilters, "key");

    const filterCountToDisplay = isSmartChartFilter || isCoreReportFilters ? filterData && getAppliedFiltersCount(filterData) : filterCount;
    const hasAppliedFilters = Number(filterCountToDisplay) > 0;
    const selectedAssetLifecycle = Array.isArray(filterData?.recommendation_type) ? filterData.recommendation_type[0] : "";
    const renderPillGroup = ({ label, options, isSelected, onSelect, multi = false }) => (
        <div className={`filter-pill-group ${multi ? "multi" : ""}`}>
            <span className="filter-pill-label">{label}</span>
            <div className="filter-pill-options">
                {options.map(option => {
                    const active = isSelected(option);
                    return (
                        <button
                            type="button"
                            key={option.value ?? option.id}
                            className={`filter-pill-chip not-draggable ${active ? "active" : ""}`}
                            onClick={() => onSelect(option)}
                        >
                            <span className="filter-pill-dot" />
                            {option.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );

    return (
        <LoadingOverlay active={isLoading} spinner={<Loader />} fadeSpeed={10}>
            {renderConfirmationModal()}
            {renserSaveFilterModal()}
            {renderAppliedFilters()}
            {renderFavoriteRemoveConfirmationModal()}
            <div
                className={`dtl-sec modal-recom-tab-view col-md-12 filter-dashboard-modal-view${
                    isAdcOnlyProject ? " filter-dashboard-modal-view--asset-lifecycle" : ""
                }`}
            >
                <Draggable handle=".draggable" cancel=".not-draggable">
                    <div className="tab-dtl filters-popup region-mng additional-dtl addition-edit">
                        <div className="close-btn-otr">
                            <button type="button" className="close not-draggable" data-dismiss="modal" aria-label="Close" onClick={handleCancel}>
                                <span aria-hidden="true">
                                    <img src="/img/close.svg" alt="" />
                                </span>
                            </button>
                        </div>
                        <div className="d-flex header-mod-top draggable filter-dashboard-popup filter-dashboard-header">
                            <div className="filter-dashboard-title-row">
                                <h3 className="filter-head">Filters</h3>
                                <div className="filter-pill-controls">
                                    {renderPillGroup({
                                        label: "COST",
                                        options: [
                                            { label: "Construction Cost", value: false },
                                            { label: "Project Cost", value: true }
                                        ],
                                        isSelected: option => Boolean(filterData?.project_cost) === option.value,
                                        onSelect: option => toggleProjectCost(option.value)
                                    })}
                                    {renderPillGroup({
                                        label: "STATIC FCI",
                                        options: [
                                            { label: "On", value: true },
                                            { label: "Off", value: false }
                                        ],
                                        isSelected: option => (filterData?.update_fci ?? true) === option.value,
                                        onSelect: option => toggleStaticFci(option.value)
                                    })}
                                    {isDashboard &&
                                        isAdcOnlyProject &&
                                        renderPillGroup({
                                            label: "ASSET LIFECYCLE",
                                            options: assetLifecycleOptions,
                                            isSelected: option => selectedAssetLifecycle === option.value,
                                            onSelect: option => toggleAssetLifecycle(option)
                                        })}
                                    {isDashboard &&
                                        renderPillGroup({
                                            label: "Dashboard Source",
                                            options: cspStatusOptions,
                                            isSelected: option => selectedCspStatuses.includes(option.id),
                                            onSelect: option => toggleCspStatus(option.id),
                                            multi: true
                                        })}
                                </div>
                            </div>
                        </div>
                        <div className="tab-active location-sec recom-sec main-dtl-add recommendation-form add-recommendation not-draggable filter-dashboard-popup">
                            <div className="col-md-12 detail-recom add-details-outer">
                                <div className="table-top-menu outer-flx-section">
                                    <ReactTooltip
                                        id="recommandation_detils"
                                        effect="solid"
                                        className="rc-tooltip-custom-class"
                                        backgroundColor="#007bff"
                                        place="left"
                                    />
                                    <ReactTooltip
                                        id="master_filter_dropdown"
                                        className="rc-tooltip-custom-class"
                                        effect="solid"
                                        place="left"
                                        backgroundColor="#007bff"
                                        delayShow={500}
                                    />
                                    <ul className={``}>
                                        {Object.keys(tabs).map(tab => {
                                            const tabActiveFilterCount =
                                                tab !== "favorites"
                                                    ? getFilterCountByTab(tab, isSmartChartFilter || isCoreReportFilters)
                                                    : 0;
                                            const hasTabActiveFilters = tabActiveFilterCount > 0;
                                            return (
                                                <li
                                                    className={`${activeTab === tab ? "active" : ""}${hasTabActiveFilters ? " has-active-filters" : ""}`}
                                                    key={tab}
                                                    onClick={() => {
                                                        setActiveTab(tab);
                                                        setShowDropdown("");
                                                        setShowWildcard("");
                                                    }}
                                                >
                                                    {tabs[tab].label}
                                                    {hasTabActiveFilters && (
                                                        <span
                                                            className="filter-tab-indicator"
                                                            title={`${tabActiveFilterCount} active filter${tabActiveFilterCount === 1 ? "" : "s"}`}
                                                        />
                                                    )}
                                                </li>
                                            );
                                        })}
                                    </ul>
                                    <div className="filter-dashboard-actions-row filter-dashboard-popup not-draggable">
                                        <div className="clr-btn">
                                            <div className="filter-actions-left">
                                                <div className="search search-box-asset filter-field-finder mr-2 not-draggable">
                                                    <FilterSearch fieldSearch={fieldSearch} setFieldSearch={setFieldSearch} fields={initialFields} />
                                                </div>
                                            </div>
                                            <div className="filter-actions-right">
                                                <button
                                                    type="button"
                                                    className="wild-button cursor-pointer not-draggable"
                                                    onClick={() => setWildcardField(!showWildcardField)}
                                                >
                                                    <img src={WildcardIcon} alt="" /> Wildcard
                                                </button>
                                                {hasAppliedFilters && (
                                                    <div
                                                        className="view view-filter-otr cursor-pointer"
                                                        onClick={
                                                            isDashboard || isSmartChartFilter || isCoreReportFilters
                                                                ? () => setShowAppliedFilters(true)
                                                                : openAppliedFiltersPopup
                                                        }
                                                    >
                                                        <div className="view-inner filter-all">
                                                            <img
                                                                src="/img/filter.svg"
                                                                alt=""
                                                                className={"filtrImg"}
                                                                data-tip="Applied Filters"
                                                                data-for="recommandation_detils"
                                                            />
                                                            <span className="notifyTxt">{filterCountToDisplay}</span>
                                                        </div>
                                                    </div>
                                                )}
                                                <button
                                                    className={`btn filter-clear-btn not-draggable ${hasAppliedFilters ? "has-filters" : ""}`}
                                                    onClick={() => clearAllFilters(isSmartChartFilter || isCoreReportFilters)}
                                                >
                                                    <i className="fas fa-times mr-2"></i>
                                                    {isRecommendationTable ? "Clear LOCAL Filters Only" : "Clear All"}
                                                </button>
                                                {(isDashboard || isRecommendationTable) && openSavedFilters && (
                                                    <button
                                                        type="button"
                                                        className={`btn btn-primary btn-sm not-draggable saved-filter-btn`}
                                                        onClick={openSavedFilters}
                                                    >
                                                        <i className="fas fa-bookmark mr-1" />
                                                        Saved Filters
                                                        {queries?.length > 0 && <span className="notifyTxt ml-1">({queries.length})</span>}
                                                    </button>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="outer-rcm recommendations">
                                    <div className="cnt-sec" ref={sectionRef}>
                                        <div className="row">
                                            <div className="col-md-12 pr-0">
                                                <div id="accordion">
                                                    {activeTab === "favorites" && (isDashboard || isRecommendationTable) ? (
                                                        <div className={`card`}>
                                                            <div className={"collapse show"} aria-labelledby={"heading"}>
                                                                <div className="card-body">
                                                                    <div className="outer-rcm mt-1">
                                                                        {uniqueFavFilters.map(field => (
                                                                            <FilterItem
                                                                                elem={field}
                                                                                showDropDown={showDropdown}
                                                                                handleFilterView={handleFilterView}
                                                                                options={field.options || masterFilterList[field.key]}
                                                                                totalCount={masterFilterCount?.[field.key]}
                                                                                isLoading={dropdownLoader[field.key]}
                                                                                key={field.key}
                                                                                filterData={filterData}
                                                                                handleFilterUpdate={handleFilterUpdate}
                                                                                yearValues={yearValues}
                                                                                setShowDropdown={setShowDropdown}
                                                                                showWildcard={showWildcard}
                                                                                setShowWildcard={setShowWildcard}
                                                                                showWildcardField={showWildcardField}
                                                                                setWildCardFilter={setWildCardFilter}
                                                                                isSmartChartFilter={isSmartChartFilter}
                                                                                isCoreReportFilters={isCoreReportFilters}
                                                                                core_report_req_filters={core_report_req_filters}
                                                                                isDashboard={isDashboard}
                                                                                toggleFavorite={toggleFavorite}
                                                                                favorites={favorites}
                                                                                isRecommendationTable={isRecommendationTable}
                                                                            />
                                                                        ))}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        tabs[activeTab].bands
                                                            .filter(band => filterFields.some(field => field.band === band))
                                                            .map(band => (
                                                                <RecommendationBand
                                                                    bandId={band?.toLowerCase()?.split(" ").join("_")}
                                                                    label={getDashboardFilterBandLabel(band)}
                                                                    showBand={showBands}
                                                                    handleBandClick={handleBandClick}
                                                                    key={band}
                                                                    filteredCount={getFilterCountByBand(
                                                                        band,
                                                                        isSmartChartFilter || isCoreReportFilters
                                                                    )}
                                                                    MainFields={
                                                                        <>
                                                                            {filterFields
                                                                                .filter(elem => (elem.isDynamicField ? elem.tab === activeTab : true))
                                                                                .filter(elem => elem.band === band && !elem.hide)
                                                                                .filter((elem, index) => index < 3)
                                                                                .map(field => (
                                                                                    <FilterItem
                                                                                        elem={field}
                                                                                        showDropDown={showDropdown}
                                                                                        handleFilterView={handleFilterView}
                                                                                        options={field.options || masterFilterList[field.key]}
                                                                                        totalCount={masterFilterCount?.[field.key]}
                                                                                        isLoading={dropdownLoader[field.key]}
                                                                                        key={field.key}
                                                                                        filterData={filterData}
                                                                                        handleFilterUpdate={handleFilterUpdate}
                                                                                        yearValues={yearValues}
                                                                                        setShowDropdown={setShowDropdown}
                                                                                        showWildcard={showWildcard}
                                                                                        setShowWildcard={setShowWildcard}
                                                                                        showWildcardField={showWildcardField}
                                                                                        setWildCardFilter={setWildCardFilter}
                                                                                        isSmartChartFilter={isSmartChartFilter}
                                                                                        isCoreReportFilters={isCoreReportFilters}
                                                                                        core_report_req_filters={core_report_req_filters}
                                                                                        isDashboard={isDashboard}
                                                                                        toggleFavorite={toggleFavorite}
                                                                                        favorites={favorites}
                                                                                        isRecommendationTable={isRecommendationTable}
                                                                                    />
                                                                                ))}
                                                                        </>
                                                                    }
                                                                    RestFields={
                                                                        <>
                                                                            {filterFields
                                                                                .filter(elem => (elem.isDynamicField ? elem.tab === activeTab : true))
                                                                                .filter(elem => elem.band === band && !elem.hide)
                                                                                .filter((elem, index) => index >= 3)
                                                                                .map(field => (
                                                                                    <FilterItem
                                                                                        elem={field}
                                                                                        showDropDown={showDropdown}
                                                                                        handleFilterView={handleFilterView}
                                                                                        options={field.options || masterFilterList[field.key]}
                                                                                        totalCount={masterFilterCount?.[field.key]}
                                                                                        isLoading={dropdownLoader[field.key]}
                                                                                        key={field.key}
                                                                                        filterData={filterData}
                                                                                        handleFilterUpdate={handleFilterUpdate}
                                                                                        yearValues={yearValues}
                                                                                        setShowDropdown={setShowDropdown}
                                                                                        showWildcard={showWildcard}
                                                                                        setShowWildcard={setShowWildcard}
                                                                                        showWildcardField={showWildcardField}
                                                                                        setWildCardFilter={setWildCardFilter}
                                                                                        isSmartChartFilter={isSmartChartFilter}
                                                                                        isCoreReportFilters={isCoreReportFilters}
                                                                                        core_report_req_filters={core_report_req_filters}
                                                                                        isDashboard={isDashboard}
                                                                                        toggleFavorite={toggleFavorite}
                                                                                        favorites={favorites}
                                                                                        isRecommendationTable={isRecommendationTable}
                                                                                    />
                                                                                ))}
                                                                        </>
                                                                    }
                                                                />
                                                            ))
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div ref={emptyDivRef} className="d-none" style={{ height: "500px", width: "100%" }} />
                                </div>
                            </div>
                            <div className="row">
                                <div
                                    className={`col-md-12 text-right btnOtr mt-3 mb-2 ${isDashboard || isRecommendationTable ? "btn-filter-qr" : ""}`}
                                >
                                    <div className="d-flex align-items-center">
                                        {(isDashboard || isRecommendationTable) && (
                                            <div>
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary btnRgion ml-2 ${!hasSaveFilter ? "cursor-diabled" : ""} save-fil-btn`}
                                                    onClick={handleSaveFilerModal}
                                                    disabled={!hasSaveFilter}
                                                >
                                                    Save Filter
                                                </button>
                                            </div>
                                        )}
                                        {(isDashboard || isRecommendationTable) &&
                                            ((filterData && Object.keys(filterData || {})?.filter(key => key !== "exclude_filters")?.length > 0) ||
                                                Object.keys(filterData?.exclude_filters || {})?.length > 0 ||
                                                queries?.length > 0) && (
                                                <h3 className="filter-head m-0 ml-2">
                                                    <span className="query-badge">
                                                        <img src="/img/edit-highlighter.svg" alt="" width={16} />{" "}
                                                        {`${
                                                            Object.keys(filterData)?.filter(key => key !== "exclude_filters")?.length > 0 ||
                                                            Object.keys(filterData?.exclude_filters || {}).length > 0
                                                                ? "Active Filter(s)"
                                                                : ""
                                                        }${
                                                            (Object.keys(filterData)?.filter(key => key !== "exclude_filters")?.length > 0 ||
                                                                Object.keys(filterData?.exclude_filters || {})?.length > 0) &&
                                                            queries.length > 0
                                                                ? " and"
                                                                : ""
                                                        } ${
                                                            queries && queries?.length > 0 ? "Saved Filter(s)" : ""
                                                        } are applied. You are viewing a partial/filtered dataset`}
                                                    </span>
                                                </h3>
                                            )}
                                    </div>
                                    <div>
                                        <button type="button" className={`btn btn-secondary btnClr`} onClick={handleCancel}>
                                            Cancel
                                        </button>

                                        <button
                                            type="button"
                                            className={`btn btn-primary btnRgion ml-2 ${!isDirty ? "cursor-diabled" : ""}`}
                                            disabled={!isDirty}
                                            onClick={() => handleSubmit(isCoreReportFilters || isSmartChartFilter)}
                                        >
                                            Update
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Draggable>
            </div>
        </LoadingOverlay>
    );
};
